import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {environment} from "@environment";
import {
  CalendarViewType,
  Competitor,
  CompetitorResults,
  EventItem,
  Lookups,
  Race,
  RegistrationStatus,
  SportIconMapping,
  UserEvent
} from "@model";
import {AbstractComponent} from "../../abstract.component";

@Component({
  selector: 'app-user-event-grid-item',
  templateUrl: './user-event-grid-item.component.html',
  styleUrl: './user-event-grid-item.component.scss',
  standalone: false
})
export class UserEventGridItemComponent extends AbstractComponent implements OnInit {
  @Input() userEvent: UserEvent | undefined;
  @Input() type: UserEventGridItemType = UserEventGridItemType.UPCOMING;
  @Output() onRightButtonClickCallback: EventEmitter<void> = new EventEmitter<void>();
  @Output() onLeftButtonClickCallback: EventEmitter<void> = new EventEmitter<void>();
  @Input() rightButtonKey: string = '';
  @Input() leftButtonKey: string = '';
  @Input() showLeftActionButton: boolean = true;
  @Input() showRightActionButton: boolean = true;
  @Input() layout: CalendarViewType | undefined;
  @Input({required: true}) languages: Lookups[] = [];

  eventItem: EventItem | undefined;
  raceItem: Race | undefined;
  competitor: Competitor | undefined;
  competitorResult: CompetitorResults | undefined;

  lengths: (string | undefined)[] = [];
  paymentCompleted: boolean = true;
  currentLayout: CalendarViewType = CalendarViewType.LIST;

  constructor(public translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.paymentCompleted = this.userEvent?.registrationStatus === RegistrationStatus.CONFIRMED;
    this.eventItem = this.userEvent?.event;
    this.raceItem = this.userEvent?.race;
    this.competitor = this.userEvent?.competitor;
    this.competitorResult = this.userEvent?.result;

    this.updateLayout();
    this.subscriptions.push(
        this.isMobile$.subscribe(() => this.updateLayout()),
        this.isMdScreen$.subscribe(() => this.updateLayout())
    );
  }

  private updateLayout(): void {
    this.currentLayout = this.layout ?? (this.isMdScreen || this.isMobile
      ? CalendarViewType.GRID
      : CalendarViewType.LIST);
  }

  protected readonly environment = environment;
  protected readonly SportIconMapping = SportIconMapping;
  protected readonly UserEventGridItemType = UserEventGridItemType;
  protected readonly CalendarViewType = CalendarViewType;

  onRightButtonClick(): void {
    this.onRightButtonClickCallback.emit();
  }

  onLeftButtonClick(): void {
    this.onLeftButtonClickCallback.emit();
  }

}

export enum UserEventGridItemType {
  UPCOMING = 1,
  FINISHED = 2
}
